import type { MeetingRecap, MeetingRecapOutcome } from '@/types/review/PostReviewMeeting';

/** A recap without an outcome predates 15411 and was always read in full. */
export const recapOutcome = (recap: MeetingRecap): MeetingRecapOutcome =>
    recap.outcome === 'incomplete' || recap.outcome === 'unusable' ? recap.outcome : 'usable';
